<template>
    <div class="content-box first" v-loading="dataLoading">
        <div class="pay-box">
            <div class="vip-cont">
                <div class="bg">
                    <img v-if="$store.state.userType == 1" src="@/assets/img/card.png" />
                    <img v-if="$store.state.userType == 3" src="@/assets/img/card3.png" />
                    <p>年服务费{{ $store.state.userType == 1 ? '' : '.企业版' }}</p>
                    <b>￥{{ $store.state.userType == 1 ? '99.00' : '999.00' }}</b>
                </div>
                <dl class="color-info">
                    <dd>
                        <label>服务时间</label>
                        <span class="color-font-normal">{{ data && data.startTimeStr }}</span>
                        至
                        <span class="color-font-normal">{{ data && data.endTimeStr }}</span>
                    </dd>
                    <dd>
                        <label>支付金额</label>
                        <span class="color-font-normal">{{ data && data.payableAmount }}</span>
                        元
                    </dd>
                </dl>
                <div v-if="data && data.form" class="pay-code">
                    <iframe :src="aliPayUrl" scrolling="no" frameborder="0"></iframe>
                </div>
                <div class="amount">
                    扫码支付：
                    <b>{{ data && data.payableAmount }}元</b>
                    <br />
                    <el-button type="text" @click="dialogVisible = true">邀请码优惠支付</el-button>
                </div>
                <div v-if="data" class="page-btn-box">
                    <el-button type="primary" @click="onSubmit" :loading="btnLoading">支付完成</el-button>
                </div>
            </div>
        </div>
        <div class="service-cont">
            <div class="title">服务内容</div>
            <ul>
                <li>全球发行</li>
                <li>200+平台渠道</li>
                <li>100%版税收益</li>
                <li>100%版权拥有</li>
                <li>全年限量30首歌曲发行</li>
                <li>快速审核</li>
                <li>1对1专享服务</li>
                <li>定时发布</li>
                <li>数据报表</li>
            </ul>
        </div>
        <el-dialog
            title="邀请码"
            :visible.sync="dialogVisible"
            center
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="500px"
            append-to-body
        >
            <div class="dialog-content">
                <el-input v-model="params.invitationCodeId" placeholder="请输入邀请码"></el-input>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button
                    type="primary"
                    @click="
                        getPayData();
                        dialogVisible = false;
                    "
                >
                    确 定
                </el-button>
            </div>
        </el-dialog>
        <el-dialog
            :title="isRenewal ? '发行服务续费成功' : '入会成功！'"
            append-to-body
            :visible.sync="payDialogVisible"
            :show-close="false"
            width="40%"
            center
        >
            <span v-if="isRenewal">继续享受秀动发行的快速、丰富的发行服务吧，服务有效期至：{{ this.data && this.data.endTimeStr }}</span>
            <span v-else>开始享受秀动发行的快速、丰富的发行服务吧，服务有效期至：{{ this.data && this.data.endTimeStr }}</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="countdownCount == 0 ? true : false" @click="goAlbumList()">
                    {{ countdownCount > 0 ? `${countdownCount}秒后自动，` : '' }}进入专辑页面
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dataLoading: false,
            btnLoading: false,
            params: {
                invitationCodeId: '',
                qrcodeWidth: 140,
            },
            data: null,
            dialogVisible: false,
            aliPayUrl: '',
            payDialogVisible: false,
            invitaionCodeFrom: null,
            countdownTime: null,
            countdownCount: 10,
        };
    },
    computed: {
        isRenewal() {
            if (this.$store.getters.userState >= 5) return true;
            return false;
        },
        vip() {
            return this.$store.state.verify && this.$store.state.verify.vip;
        },
    },
    mounted() {
        this.$store.dispatch('getUserInfo');
        const {userState} = this.$store.getters;
        const {invitaionCodeFrom} = this.$store.state.userInfo || {};
        if (invitaionCodeFrom && userState < 5) this.invitaionCodeFrom = invitaionCodeFrom;
        this.enterpriseUpgrade();
        this.getPayData();
    },
    methods: {
        async enterpriseUpgrade() {
            const {isEnterpriseUpgrade} = this.$store.getters;
            // 企业升级中不能进行付费
            if (isEnterpriseUpgrade) {
                await this.$confirm('您当前处于企业升级中，请升级完成后再购买发行服务', '温馨提示', {
                    type: 'warning',
                    center: true,
                    showClose: false,
                    showCancelButton: false,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    confirmButtonText: '知道了',
                });
                this.$router.push({path: '/manage/accountManage'});
            }
        },
        // 设置支付信息
        setPlayData(result) {
            this.data = result;
            // 此处邀请码如果为失效状态的话，需要重新请求一次数据，拿到正确的支付参数
            if ((this.invitaionCodeFrom || this.params.invitationCodeId) && !result.ifCodeAvailable) {
                this.$message.error('当前邀请码次数已用尽，请更换邀请码');
                this.retry();
            } else {
                this.aliPayUrl = '/aliPay?customerService=0&form=' + encodeURIComponent(result.form);
            }
        },
        // 获取企业支付信息
        async getEnterprisePayData() {
            this.dataLoading = true;
            const response = await this.$request.post(
                '/pay/ent/param',
                {},
                {
                    params: {
                        ...this.params,
                        invitationCodeId: this.params.invitationCodeId || this.invitaionCodeFrom,
                    },
                }
            );
            this.dataLoading = false;
            const {state, msg, result, code} = response.data;
            if (!state) {
                if (code && code == 'param.error') return this.retry();
                return this.$message.error(msg || '获取数据失败,请重试');
            }
            this.setPlayData(result);
        },
        //获取支付信息
        getPayData() {
            const {userType} = this.$store.state;
            if (userType == 3) return this.getEnterprisePayData();
            this.dataLoading = true;
            this.$request({
                url: '/pay/param',
                method: 'post',
                params: {
                    ...this.params,
                    invitationCodeId: this.params.invitationCodeId || this.invitaionCodeFrom,
                },
            })
                .then((res) => {
                    const {state, msg, result, code} = res.data;
                    if (state) {
                        this.setPlayData(result);
                    } else {
                        if (msg) this.$message.error(msg);
                        if (code && code == 'param.error') this.retry();
                    }
                })
                .catch(() => {
                    this.$message.error('获取数据失败,请重试');
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        // 重试
        retry() {
            this.params.invitationCodeId = '';
            this.invitaionCodeFrom = null;
            this.getPayData();
        },
        // 去专辑列表页面
        async goAlbumList() {
            if (this.$confirm && this.$confirm.close) this.$confirm.close();
            this.payDialogVisible = false;
            this.$router.push({path: '/manage/album/list'});
        },
        //检测支付完成
        async onSubmit() {
            this.btnLoading = true;
            const _url = this.data.isFree ? '/pay/zero' : '/pay/success-verify';
            const {invitaionCodeFrom = null} = this.$store.state.userInfo || {};
            this.$request({
                url: _url,
                method: 'post',
                params: {
                    sn: this.data.sn,
                    invitationCodeId: this.params.invitationCodeId || invitaionCodeFrom,
                },
            })
                .then((res) => {
                    const {state, msg, result} = res.data;
                    if (state == 1 && result) {
                        this.payDialogVisible = true;
                        this.countdownTime = setInterval(async () => {
                            this.countdownCount -= 1;
                            if (this.countdownCount <= 0) {
                                clearTimeout(this.countdownTime);
                                await this.$store.dispatch('getUserInfo');
                                this.goAlbumList();
                            }
                        }, 1000);
                    } else {
                        this.$message.error(msg || '未支付或支付失败,请重新支付');
                    }
                })
                .catch(() => {
                    this.$message.error('操作失败,请重试');
                })
                .finally(() => {
                    this.btnLoading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.content-box.first {
    overflow: visible;
}

.tips {
    position: absolute;
    right: 290px;
    top: 40px;
    z-index: 14;

    .el-button {
        color: #909399;
    }
}

.pay-box {
    display: flex;
    padding: 20px 0;
    padding-right: 210px;
    position: relative;

    .vip-cont {
        text-align: center;
        width: 500px;
        margin: 0 auto;
        position: relative;

        .bg {
            position: relative;

            p {
                position: absolute;
                bottom: 62px;
                right: 128px;
                font-size: 10px;
                font-weight: 400;
                color: #ffffff;
                line-height: 10px;
            }

            b {
                position: absolute;
                bottom: 24px;
                right: 128px;
                font-size: 30px;
                line-height: 30px;
                font-weight: 600;
                color: #ffffff;
            }
        }

        img {
            width: 100%;
        }

        .pay-code {
            width: 140px;
            height: 140px;
            margin: 0 auto;
        }

        .color-info {
            width: 270px;
            margin: 25px auto 35px;
            text-align: right;
            font-size: 14px;
            font-weight: 400;
            color: #000000;
            line-height: 14px;

            dd {
                padding: 15px 0;
            }

            label {
                float: left;
                color: #909399;
            }
        }

        .amount {
            margin-top: 20px;
            color: #000000;

            b {
                font-size: 20px;
            }
        }

        .page-btn-box {
            text-align: center;
            margin-top: 30px;
        }
    }

    .pay-code {
        background: #f8f8f8;

        iframe {
            width: 100%;
            height: 100%;
        }
    }
}

.service-cont {
    width: 250px;
    position: absolute;
    top: -64px;
    right: 0px;
    z-index: 14;
    height: 110%;
    border-radius: 0 6px 6px 0;
    background: linear-gradient(270deg, #ffffff 0%, #f7f5ff 100%);
    padding: 70px 30px;

    .title {
        font-size: 16px;
        font-weight: 600;
        color: #000000;
        line-height: 16px;
        margin-bottom: 40px;
    }

    ul {
        li {
            font-size: 12px;
            font-weight: 400;
            color: #000000;
            line-height: 12px;
            margin-bottom: 30px;
            position: relative;

            &::before {
                content: '';
                background: url('~@/assets/img/gougou.svg') no-repeat center;
                width: 12px;
                height: 10px;
                background-size: cover;
                display: inline-block;
                margin-right: 15px;
            }
        }
    }
}
</style>
